'use client';

import dynamic from 'next/dynamic';
import { ProductDetailsMapperProps } from '../types';

const ProductDetailsMapper = dynamic(() => import('./product-details-mapper'));

// Passes the product + the awaited CT data through to the mapper. The
// mapper handles both the missing-product (NotFound) branch and the
// CT-enriched render.
const ProductDetailsClientWrapper = ({ product, ctData }: ProductDetailsMapperProps) => {
  return <ProductDetailsMapper product={product} ctData={ctData} />;
};

export default ProductDetailsClientWrapper;
